var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiStepCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign-screen-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layers_light-1",
    transform: "translate(43, 40)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#59616E",
    strokeWidth: 3,
    strokeLinejoin: "round",
    points: "20.4961236 0 1.36278036 8.18192637 20.4961236 16.3638527 39.6295564 8.18192637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63758182,17.2253352 L0.828319273,20.5647513 C0.325823273,20.779564 0,21.2725623 0,21.8182224 C0,22.363585 0.325823273,22.8565832 0.828319273,23.0716935 L19.9614836,31.2536199 C20.3052873,31.400597 20.6947127,31.400597 21.0385164,31.2536199 L40.1719491,23.0716935 C40.6740873,22.8565832 41,22.363585 41,21.8182224 C41,21.2725623 40.6740873,20.779564 40.1719491,20.5647513 L32.3622691,17.2253352 L28.8929236,18.7090011 L36.1637891,21.8182224 L20.5,28.5163936 L4.83609164,21.8182224 L12.1069869,18.7090011 L8.63758182,17.2253352 Z",
    id: "Path",
    fill: "#59616E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63758182,30.86178 L0.828319273,34.2008985 C0.325823273,34.4160088 0,34.9090071 0,35.4543696 C0,36.0000298 0.325823273,36.493028 0.828319273,36.7078408 L19.9614836,44.8897671 C20.3052873,45.0367443 20.6947127,45.0367443 21.0385164,44.8897671 L40.1719491,36.7078408 C40.6740873,36.493028 41,36.0000298 41,35.4543696 C41,34.9090071 40.6740873,34.4160088 40.1719491,34.2008985 L32.3622691,30.86178 L28.8929236,32.3452376 L36.1637891,35.4543696 L20.5,42.1528384 L4.83609164,35.4543696 L12.1069869,32.3452376 L8.63758182,30.86178 Z",
    id: "Path",
    fill: "#59616E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiStepCampaign);
export default __webpack_public_path__ + "static/media/MultiStep_Campaign.19fb0e5b9364c1372c88b7bff6baefdb.svg";
export { ForwardRef as ReactComponent };